import { API_ROUTES, CONFIG } from "../../utils/constants";
import { AxiosBase } from "./index";

export default class SendMessageService extends AxiosBase {
  getAllUsers = async ({
    page,
    limit,
    navigate,
    filterValue,
    name,
    email,
    sortField,
    sortDirection,
  }) => {
    try {
      let url = `${API_ROUTES.USERMANAGEMENT.GET_USERS}?page=${page}&limit=${limit}&status=${filterValue}`;
      if (sortField && sortDirection) {
        url += `&sortKey=${sortField}&sortDirection=${sortDirection}`;
      }
      if (name) {
        url += `&name=${encodeURIComponent(name)}`;
      }
      if (email) {
        url += `&email=${encodeURIComponent(email)}`;
      }
      const response = await this.requests.get(url);
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getAllUserGroups = async ({
    page,
    limit,
    name,
    sortField,
    sortDirection,
    navigate,
  }) => {
    try {
      let url = `${API_ROUTES.BROADCAST.GROUPS}?page=${page}&limit=${limit}`;

      if (sortField && sortDirection) {
        url += `&sortKey=${sortField}&sortDirection=${sortDirection}`;
      }

      if (name) {
        url += `&name=${encodeURIComponent(name)}`;
      }

      const response = await this.requests.get(url);
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  sendMessage = async (payload) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.BROADCAST.SEND_MESSAGE}`,
        payload,
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  uploadMedia = async (formData, type, onProgress) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.BROADCAST.UPLOAD_MEDIA}/${type}`,
        formData,
        {
          timeout: CONFIG.UPLOAD_TIMEOUT,
          onUploadProgress: onProgress
            ? (event) => {
                const percent = event.total
                  ? Math.round((event.loaded * 100) / event.total)
                  : 0;
                onProgress(percent);
              }
            : undefined,
        },
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };

  //Schedule
  scheduleSend = async (payload) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.BROADCAST.SCHEDULE_SEND}`,
        payload,
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  getScheduled = async ({ page, limit }) => {
    try {
      const response = await this.requests.get(
        `${API_ROUTES.BROADCAST.GET_SCHEDULED}?page=${page}&limit=${limit}`,
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  deleteScheduled = async (scheduleId) => {
    try {
      const response = await this.requests.delete(
        `${API_ROUTES.BROADCAST.DELETE_SCHEDULED}/${scheduleId}`,
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
  updateScheduled = async (scheduleId, payload) => {
    try {
      const response = await this.requests.put(
        `${API_ROUTES.BROADCAST.UPDATE_SCHEDULED}/${scheduleId}`,
        payload,
      );
      return response;
    } catch (err) {
      if (err?.status === 401) {
      }
      throw err;
    }
  };
}
